<template>
    <nav 
        class="tw:fixed tw:bottom-0 tw:left-0 tw:right-0 tw:bg-white tw:z-1"
        role="navigation"
        :aria-label="$t('perfil.nav_movil_aria_label')"
    >
        <div class="tw:flex tw:justify-between tw:py-1">
            <button
                v-for="tab in tabs"
                :key="tab.id"
                :data-testid="`sidebar-${tab.id}`"
                class="tw:flex tw:flex-col tw:items-center tw:justify-center tw:flex-1 tw:h-full tw:transition-all tw:duration-100 tw:border-0"
                :class="getButtonClass(tab.id)"
                :aria-current="isActive(tab.id) ? 'page' : null"
                @click="handleTabChange(tab.id)"
            >
                <i class="material-icons tw:text-2xl" aria-hidden="true">{{ tab.icon }}</i>
                <span class="tw:hidden tw:xxs:block tw:text-xs  tw:w-full tw:text-center tw:capitalize">
                    {{ tab.shortLabel }}
                </span>
            </button>
        </div>
    </nav>
</template>

<script setup>
    const props = defineProps({
        tabs: { type: Array, required: true },
        activeTab: { type: String, required: true }
    });
    
    const emit = defineEmits(['change-tab']);
    
    const isActive = tabId => props.activeTab === tabId;
    const handleTabChange = tabId => emit('change-tab', tabId);
    
    const getButtonClass = tabId => {
        return isActive(tabId) ? 'active-tab-mobile' :'';
    };
</script>

<style scoped>
    .active-tab-mobile {
        color: var(--altcolor);
    }
</style>
